import { VBanner } from 'vuetify/lib/components/VBanner';
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsDivider } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRangeSlider } from 'vuetify/lib/components/VRangeSlider';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VSheet,
    { staticClass: "mx-md-5 mx-2" },
    [
      _c(
        VBreadcrumbs,
        [
          _c(
            VBreadcrumbsItem,
            { attrs: { exact: true, to: { name: "home", params: {} } } },
            [_vm._v("Home")]
          ),
          _c(VBreadcrumbsDivider, [_vm._v("/")]),
          _c(
            VBreadcrumbsItem,
            {
              attrs: {
                exact: true,
                to: { name: "AvailableUnits", params: {} },
                active: "",
              },
            },
            [_vm._v(" Available Units ")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "d-flex" },
        [
          _c("product-select", {
            attrs: { label: "Choose a product", "return-object": "" },
            on: { input: _vm.findInventories },
            model: {
              value: _vm.product,
              callback: function ($$v) {
                _vm.product = $$v
              },
              expression: "product",
            },
          }),
          _vm.downloadUnits && _vm.downloadUnits.length > 0
            ? _c("download", {
                staticClass: "ml-2 ml-md-5",
                attrs: { fileName: "availableUnits" },
                model: {
                  value: _vm.downloadUnits,
                  callback: function ($$v) {
                    _vm.downloadUnits = $$v
                  },
                  expression: "downloadUnits",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.loading
        ? _c(VProgressLinear, {
            staticClass: "my-1",
            attrs: { indeterminate: "" },
          })
        : _vm._e(),
      _c(
        VSheet,
        { staticClass: "pa-2 mt-4", attrs: { elevation: 2 } },
        [
          _vm.units.length > 0
            ? _c(VTextField, {
                staticClass: "mx-2",
                attrs: {
                  "append-icon": "mdi-magnify",
                  label: "Search",
                  "single-line": "",
                  "hide-details": "",
                },
                model: {
                  value: _vm.search,
                  callback: function ($$v) {
                    _vm.search = $$v
                  },
                  expression: "search",
                },
              })
            : _vm._e(),
          _vm.dates && _vm.dates.length > 4 && _vm.units.length > 10
            ? _c(VRangeSlider, {
                staticClass: "align-center mt-4",
                attrs: {
                  max: _vm.maxDate,
                  min: _vm.minDate,
                  "hide-details": "",
                },
                on: { change: _vm.filter },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "prepend",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "text-caption",
                              staticStyle: { "white-space": "nowrap" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("formatDateYear")(
                                    _vm.dates[_vm.dateRange[0]]
                                  )
                                )
                              ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "append",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "text-caption",
                              staticStyle: { "white-space": "nowrap" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("formatDateYear")(
                                    _vm.dates[_vm.dateRange[1] - 1]
                                  )
                                )
                              ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1895198466
                ),
                model: {
                  value: _vm.dateRange,
                  callback: function ($$v) {
                    _vm.dateRange = $$v
                  },
                  expression: "dateRange",
                },
              })
            : _vm._e(),
          _c(VDataTable, {
            staticClass: "my-8",
            attrs: {
              "hide-default-footer": _vm.units.length < 1,
              "hide-default-header": _vm.units.length < 1,
              items: _vm.filterUnits,
              headers: _vm.headers,
              "item-key": "id",
              search: _vm.search,
            },
            scopedSlots: _vm._u([
              {
                key: "item.checkbox",
                fn: function ({ item }) {
                  return [
                    _c(VCheckbox, {
                      on: {
                        change: function ($event) {
                          return _vm.confirmStatus(item)
                        },
                      },
                      model: {
                        value: item.selected,
                        callback: function ($$v) {
                          _vm.$set(item, "selected", $$v)
                        },
                        expression: "item.selected",
                      },
                    }),
                  ]
                },
              },
              {
                key: "item.stockDate",
                fn: function ({ item }) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("formatDateYear")(item.stockDate)) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "item.amountPerUnit",
                fn: function ({ item }) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("formatNumber")(item.amountPerUnit)) +
                        " " +
                        _vm._s(item.unitMeasure) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "item.confirmed",
                fn: function ({ item }) {
                  return [
                    item.confirmed
                      ? _c("span", [
                          _vm._v(
                            "By " +
                              _vm._s(item.confirmedBy) +
                              " on " +
                              _vm._s(
                                _vm._f("formatDateTime")(item.confirmedTime)
                              )
                          ),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm.filterUnits && _vm.filterUnits.length < 1 && !_vm.product
            ? _c(
                "div",
                [
                  _c(
                    VBanner,
                    {
                      staticClass: "text-center",
                      attrs: {
                        icon: "mdi-alert-circle-outline",
                        color: "primary",
                        dark: "",
                        rounded: "",
                        elevation: 2,
                      },
                    },
                    [_vm._v("Please choose a product first.")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }